import { apiFetch } from '@/utils/api-fetch'
import { createSharedComposable } from '@vueuse/core'
import { ref, unref } from 'vue'
import { useFramework } from '../useFramework'

/**
 * Use the world tiles.
 */
export const useTiles = createSharedComposable(() => {
    /**
     * List of tiles.
     */
    const tiles = ref<Tile[]>()

    /**
     * Get the framework.
     */
    const { entireFramework } = useFramework()

    /**
     * Fetch the tiles.
     */
    async function fetch() {
        tiles.value = await apiFetch<Tile[]>('tiles')
    }

    /**
     * Get the tile dimnesion.
     */
    function getDimension(tile: Tile) {
        return unref(entireFramework).find(({ id }) => id === tile.dimension)
    }

    /**
     * Get the color of the dimension.
     */
    function getDimensionColor(tile: Tile) {
        return getDimension(tile)?.labelColor
    }

    return {
        tiles,
        fetch,
        getDimension,
        getDimensionColor
    }
})
